import React from 'react';
import './Internship.css';
import { useNavigate } from 'react-router-dom';

const Internship = () => {
    const navigate = useNavigate();

  const handleApplyClick = () => {
    navigate('/contact-us');
  };

  return (
    <div className="internship-page">
      <div className="container">
        <h1>Internship Program</h1>
        
        <section className="internship-intro">
          <img 
            src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=400&fit=crop&crop=face" 
            alt="Law students studying" 
            className="intro-image"
          />
          <p>
            Yadi Legal Services offers comprehensive internship opportunities for law students 
            seeking practical experience in various areas of legal practice. Our program is 
            designed to provide hands-on learning and professional development.
          </p>
        </section>

        <section className="program-details">
          <h2>Program Overview</h2>
          <div className="details-grid">
            <div className="detail-card">
              <h3>Duration</h3>
              <p>Flexible internship periods ranging from 2 weeks to 6 months</p>
            </div>
            <div className="detail-card">
              <h3>Areas of Exposure</h3>
              <p>Civil Law, Criminal Law, Corporate Law, Family Law, and more</p>
            </div>
            <div className="detail-card">
              <h3>Learning Opportunities</h3>
              <p>Court proceedings, legal research, drafting, and client interaction</p>
            </div>
          </div>
        </section>

        <section className="what-you-learn">
          <h2>What You'll Learn</h2>
          <ul className="learning-list">
            <li>Legal research and case analysis</li>
            <li>Drafting of legal documents and pleadings</li>
            <li>Court procedure and litigation process</li>
            <li>Client counseling and communication</li>
            <li>Case preparation and strategy development</li>
            <li>Professional ethics and legal practice standards</li>
          </ul>
        </section>

        <section className="eligibility">
          <h2>Eligibility Criteria</h2>
          <ul className="eligibility-list">
            <li>Currently enrolled in a recognized law school</li>
            <li>Completed at least 2 years of law studies</li>
            <li>Strong academic record</li>
            <li>Genuine interest in legal practice</li>
            <li>Good communication skills</li>
          </ul>
        </section>

        <section className="application-process">
          <h2>Application Process</h2>
          <ol className="process-steps">
            <li>Submit your resume and cover letter</li>
            <li>Provide academic transcripts</li>
            <li>Include a letter of recommendation from faculty</li>
            <li>Attend an interview (if shortlisted)</li>
            <li>Complete necessary documentation</li>
          </ol>
        </section>

        <section className="benefits">
          <h2>Internship Benefits</h2>
          <ul className="benefits-list">
            <li>Practical legal experience</li>
            <li>Mentorship from experienced Legal Practitioners</li>
            <li>Networking opportunities</li>
            <li>Certificate of completion</li>
            <li>Potential for future employment opportunities</li>
          </ul>
        </section>

        <section className="apply-now">
          <h2>Ready to Apply?</h2>
          <p>
            Send your application materials to our office or contact us for more information 
            about current internship opportunities.
          </p>
           <button 
            className="apply-button"
            onClick={handleApplyClick}
          >
            Apply Now
          </button>
        </section>
      </div>
    </div>
  );
};

export default Internship;
